import { render } from "./VentaView.vue?vue&type=template&id=8d208daa"
import script from "./VentaView.vue?vue&type=script&lang=js"
export * from "./VentaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__